import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';

export const EXCHANGES: TableCols[] = [
  {
    key: 'longName',
    displayValue: 'Exchange Name',
    validators: [Validators.required],
  },
  {
    key: 'description',
    displayValue: 'Description',
    validators: [Validators.required],
  },
  {
    key: 'micCode',
    displayValue: 'MIC Code',
    validators: [Validators.required],
  },
];
